import { useContext } from "react"
import { array, func, object } from "prop-types"
import { isEmpty, filter, find, sortBy } from "lodash"
import { ReservationContext } from "source/registrations/reservations/ReservationContext"
import AddOnsFormFields from "./AddOnsFormFields"
import AttendeeTypeString from "source/registrations/reservations/AttendeeTypeString"

const selectedAddOnToString = (attendee, addOns) =>
  Object.values(attendee.addOnSelections)
    .map((addOnSelection) => {
      const addOn = addOns.find((a) => a.id === Number(addOnSelection.addOnId))

      const addOnVariation = find(addOn.addOnVariations, {
        id: Number(addOnSelection.addOnVariationId),
      })

      let addOnStr =
        addOnSelection.quantity > 1 ? ` (${addOnSelection.quantity})` : ""

      return isEmpty(addOnVariation)
        ? `${addOn.name}${addOnStr}`
        : `${addOn.name}: ${addOnVariation.name}${addOnStr}`
    })
    .join(", ")

const AddOnsForm = ({ addOns, step, attendee, onChange }) => {
  const {
    event: {
      data: { currency },
    },
  } = useContext(ReservationContext)

  const sortedAddOns = sortBy(addOns, "position")

  const addOnsForAttendeeType = filter(sortedAddOns, (addOn) =>
    attendee.attendeeType.availableAddOns.includes(addOn.id),
  )

  return (
    <div className={`${step.isCurrent ? "mb-3" : "mb-2 c-tint2"}`}>
      {step.isCurrent && (
        <>
          <div className="label">
            <AttendeeTypeString attendee={attendee} />
          </div>

          {attendee.waitlist && (
            <div className="mb-1 fs-4">
              Additional options are not available for waitlisted attendees
            </div>
          )}

          {!attendee.waitlist && addOnsForAttendeeType.length === 0 && (
            <div className="mb-1 c-tint2 fs-4">
              No Additional options available
            </div>
          )}

          {!attendee.waitlist &&
            addOnsForAttendeeType.map((addOn) => (
              <div key={addOn.id} className="mt-1">
                <AddOnsFormFields
                  attendee={attendee}
                  addOn={addOn}
                  onAddOnChange={onChange}
                  currencySymbol={currency}
                />
              </div>
            ))}
        </>
      )}

      {!step.isCurrent &&
        step.isComplete &&
        !isEmpty(attendee.addOnSelections) && (
          <div>
            {selectedAddOnToString(attendee, sortedAddOns)}
            <div className="fs-4">
              <AttendeeTypeString attendee={attendee} isTruncated />
            </div>
          </div>
        )}
    </div>
  )
}

AddOnsForm.propTypes = {
  addOns: array,
  step: object,
  attendee: object,
  onChange: func,
}

export default AddOnsForm
